/**
 * @typedef {Object} ICampaign
 * @property {number} campaign_id
 * @property {string} campaign_name
 * @property {number} email_pref Email preference to be used for this campaign.
 * Possible values are:
 * 1 - Personal
 * 2 - Professional
 * 3 - Personal -> Professional
 * 4 - Professional -> Personal
 * @property {number} useremailintegrationid UserEmailIntegration ID
 * @property {string} timezone Timezone of the campaign
 * @property {string} schedule Schedule of the campaign
 * This should be formatted as `HH:mm:ss` (24-hour format)
 * Sample: `09:00:00` // 9 AM
 * Also supports `HH:mm` (24-hour format)
 * Sample: `09:00` // 9 AM
 * Also supports range of hours in 24-hour format (separated by `-`)
 * Sample: `09:00-12:00` // 9 AM to 12 PM
 * @property {number} created_by
 * @property {boolean} is_active
 * @property {number} status Status of the campaign.
 * 1 - Active
 * 2 - Paused
 * 3 - Draft
 * 4 - Completed
 * 5 - Intgration Error
 * @property {Date} created_on
 * @property {Date} updated_on
 */

export interface ICampaign {
    id: number;
    campaign_name: string;
    email_pref: EmailPreference;
    useremailintegrationid: number;
    timezone: string;
    schedule: string;
    created_by: number;
    is_active: boolean;
    status: CampaignStatus;
    created_on: Date;
    updated_on: Date;
  }
  
  export enum EmailPreference {
    Personal = 1,
    Professional = 2,
    PersonalProfessional = 3,
    ProfessionalPersonal = 4,
  }
  
  export enum CampaignStatus {
    Active = 1,
    Paused = 2,
    Draft = 3,
    Completed = 4,
    IntegrationError = 5,
  }
  
  export interface campaignModel {
    campaign_name: string;
    recipients: number;
    pipeline: number;
    completed: number;
    opened: string;
    replied: string;
    bounced: string;
    created_on: string; 
    status: string;
  }
  
  export interface ModalData{
    campaignName: string;
  }

  export interface targetData  {
      campaign_target_id: number,
      target_id: string,
      target_name: string,
      target_meta: string,
      target_email: string,
      is_active: boolean,
      created_by: number,
      created_on: string,
      updated_on: string
  }


/**
 * @typedef {Object} ICampaignStage
 * @property {number} campaign_stage_id
 * @property {number} campaign_id
 * @property {string} subject
 * @property {string} body
 * @property {number} after_id
 * @property {number} after_minutes
 * @property {boolean} regular_days
 * @property {number} created_by
 * @property {boolean} is_active
 * @property {Date} created_on
 * @property {Date} updated_on
 */
export interface ICampaignStage {
  campaign_stage_id: number;
  stage_name: string;
  campaign_id: number;
  subject: string;
  body: string;
  after_id: number;
  after_minutes: number;
  regular_days: boolean;
  created_by: number;
  is_active: boolean;
  created_on: Date;
  updated_on: Date;
  isUnsubscribed?: boolean;
  allow_unsubscription?: boolean
}

export interface BulkReveal {
  enrichedfrom: string;
  candidates: {
    elastic_id:string,
    candidatenumber: string,
    campaign_target_id: number
  }[],
  campaign_id: number
}
